import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { config } from "vuex-module-decorators";

config.rawError = true;

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const storeOptions: StoreOptions<any> = {
  strict: debug
};

export default new Vuex.Store(storeOptions);
